import type { Scene } from '@babylonjs/core/scene';
import { FileLoader } from '@seddi/ui-babylon-core';
import { RecolorModule } from '@seddi/ui-recolor';
import { ButtonLoader } from './buttonLoader';
import { ButtonsContext } from './buttonsContext';
import { FabricLoader } from './fabricLoader';
import { FabricsContext } from './fabricsContext';
import { LogoLoader } from './logoLoader';
import { LogosContext } from './logosContext';
import { SurfaceMaterialLoader } from './surfaceMaterialLoader';
import { TextureLoader } from './textureLoader';

export class SceneResourcesContext {
  /** Scene. */
  public readonly scene: Scene;

  /** File loader. */
  public readonly fileLoader: FileLoader;
  /** Texture loader. */
  public readonly textureLoader: TextureLoader;
  /** Surface material loader. */
  public readonly surfaceMaterialLoader: SurfaceMaterialLoader;

  /** Button loader. */
  public readonly buttonLoader: ButtonLoader;
  /** Buttons context. */
  public readonly buttons: ButtonsContext;
  /** Fabric loader. */
  public readonly fabricLoader: FabricLoader;
  /** Fabrics context. */
  public readonly fabrics: FabricsContext;
  /** Logo loader. */
  public readonly logoLoader: LogoLoader;
  /** Logos context. */
  public readonly logos: LogosContext;

  /**
   * Create a new scene context.
   * @param scene - Fx scene.
   */
  constructor(scene: Scene) {
    this.scene = scene;

    this.fileLoader = new FileLoader(scene);
    this.textureLoader = new TextureLoader(scene, this.fileLoader);
    this.surfaceMaterialLoader = new SurfaceMaterialLoader(scene, this.textureLoader);

    this.buttonLoader = new ButtonLoader(scene, this.surfaceMaterialLoader);
    this.buttons = new ButtonsContext(this.buttonLoader);
    this.fabricLoader = new FabricLoader(scene, this.surfaceMaterialLoader);
    this.fabrics = new FabricsContext(this.fabricLoader, RecolorModule.context);
    this.logoLoader = new LogoLoader(scene, this.surfaceMaterialLoader);
    this.logos = new LogosContext(this.logoLoader);
  }

  /**
   * Releases resources associated with this scene.
   */
  dispose() {
    this.scene.dispose();
    void this.buttons.clear();
    void this.fabrics.clear();
    void this.logos.clear();
  }
}
